import {PlannerFeature} from '../enums'
import {usePlantConfigQuery} from '../hooks/api'

export const usePlannerFeature = (feature: PlannerFeature) => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features || []

  return availableFeatures.includes(feature)
}
